"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminQueryParams = exports.AdminPathParams = exports.AdminPages = void 0;
exports.getAdminRoutes = getAdminRoutes;
const Routes_1 = __importDefault(require("@aurora/shared-utils/helpers/urls/NextRoutes/Routes"));
/**
 * Admin pages.
 */
var AdminPages;
(function (AdminPages) {
    AdminPages["AdminPage"] = "AdminPage";
    AdminPages["ShortcutsPage"] = "ShortcutsPage";
    AdminPages["NodeSettingsPage"] = "NodeSettingsPage";
    AdminPages["NodePermissionsPage"] = "NodePermissionsPage";
    AdminPages["NodeRolesAndPermissionsPage"] = "NodeRolesAndPermissionsPage";
    AdminPages["NodeRoleAndPermissionsManagementPage"] = "NodeRoleAndPermissionsManagementPage";
    AdminPages["NodeUserRolesAndPermissionsManagementPage"] = "NodeUserRolesAndPermissionsManagementPage";
    AdminPages["DashboardPage"] = "DashboardPage";
    AdminPages["DashboardPresetPage"] = "DashboardPresetPage";
    AdminPages["CommunityStructurePage"] = "CommunityStructurePage";
    AdminPages["CommunityPermissionsPage"] = "CommunityPermissionsPage";
    AdminPages["CommunityRanksPage"] = "CommunityRanksPage";
    AdminPages["CommunityRolesAndPermissionsPage"] = "CommunityRolesAndPermissionsPage";
    AdminPages["CommunityRoleAndPermissionsManagementPage"] = "CommunityRoleAndPermissionsManagementPage";
    AdminPages["CommunityUserRolesAndPermissionsManagementPage"] = "CommunityUserRolesAndPermissionsManagementPage";
    AdminPages["CommunityBadgesPage"] = "CommunityBadgesPage";
    AdminPages["FeaturesPage"] = "FeaturesPage";
    AdminPages["ContentFeaturesPage"] = "ContentFeaturesPage";
    AdminPages["InboxFeaturesPage"] = "InboxFeaturesPage";
    AdminPages["DevelopersPage"] = "DevelopersPage";
    AdminPages["UsersPage"] = "UsersPage";
    AdminPages["AnalyticsPage"] = "AnalyticsPage";
    AdminPages["ReportsPage"] = "ReportsPage";
    AdminPages["ReportsDetailsPage"] = "ReportsDetailsPage";
    AdminPages["SystemPage"] = "SystemPage";
    AdminPages["DisplayPage"] = "DisplayPage";
    AdminPages["AuditLogPage"] = "AuditLogPage";
    AdminPages["DesignersPage"] = "DesignersPage";
    AdminPages["ModerationPage"] = "ModerationPage";
    AdminPages["AccountAndPrivacyPage"] = "AccountAndPrivacyPage";
    AdminPages["SeoPage"] = "SeoPage";
    AdminPages["CommunityContentFilterDetailPage"] = "CommunityContentFilterDetailPage";
    AdminPages["CommunityTextPage"] = "CommunityTextPage";
    AdminPages["SalesforceFeaturesPage"] = "SalesforceFeaturesPage";
    AdminPages["CategoryLocaleAssociationPage"] = "CategoryLocaleAssociationPage";
    AdminPages["OidcProviderEditPage"] = "OidcProviderEditPage";
    AdminPages["ManageUsersAdminPage"] = "ManageUsersAdminPage";
    AdminPages["ThirdPartyAnalyticsPage"] = "ThirdPartyAnalyticsPage";
    AdminPages["AutomationRulesPage"] = "AutomationRulesPage";
    AdminPages["AdminHealthCheckPage"] = "AdminHealthCheckPage";
})(AdminPages || (exports.AdminPages = AdminPages = {}));
/**
 * Admin path param slugs.
 */
var AdminPathParams;
(function (AdminPathParams) {
    AdminPathParams["NODE_ID"] = "nodeId";
    AdminPathParams["ROLE_NAME"] = "roleName";
    AdminPathParams["FEATURE_ID"] = "featureId";
    AdminPathParams["REPORT_ID"] = "reportId";
    AdminPathParams["USER_ID"] = "userId";
    AdminPathParams["CONTENT_FILTER_NAME"] = "contentFilterName";
    AdminPathParams["PRESET_ID"] = "presetId";
    AdminPathParams["OIDC_PROVIDER_ID"] = "oidcProviderId";
})(AdminPathParams || (exports.AdminPathParams = AdminPathParams = {}));
/**
 * Admin query param keys.
 */
var AdminQueryParams;
(function (AdminQueryParams) {
    /**
     * Branch name used to switch which branch is used for loading customization assets
     */
    AdminQueryParams["BRANCH_NAME"] = "branchName";
    /**
     * The timestamp when action was taken
     */
    AdminQueryParams["ACTION_TIME"] = "actionTime";
    /**
     * Param to indicate which date range is selected by default.
     */
    AdminQueryParams["DATE_RANGE"] = "dateRange";
    /**
     * Param to indicate what User is selected by default.
     */
    AdminQueryParams["USER"] = "user";
    /**
     * Param to indicate whether the Filter Component is open or not.
     */
    AdminQueryParams["FILTER_OPEN"] = "filterOpen";
})(AdminQueryParams || (exports.AdminQueryParams = AdminQueryParams = {}));
const routesCache = new Map();
/**
 * Gets or builds the end user routes for the specified base path.
 *
 * @param basePath base path that is prefixed on each route.
 */
function getAdminRoutes(basePath = null) {
    const key = basePath !== null && basePath !== void 0 ? basePath : '';
    const cachedRoutes = routesCache.get(key);
    if (cachedRoutes) {
        return cachedRoutes;
    }
    else {
        const adminRoutes = new Routes_1.default(basePath)
            // SETTINGS pages
            .add(AdminPages.ShortcutsPage, '/admin/settings/shortcuts', 'settings/ShortcutsPage/ShortcutsPage')
            .add(AdminPages.AdminPage, '/admin', 'settings/ShortcutsPage/ShortcutsPage')
            .add(AdminPages.CommunityStructurePage, '/admin/settings/structure', 'settings/community/CommunityStructurePage/CommunityStructurePage')
            .add(AdminPages.NodeSettingsPage, `/admin/settings/places/:${AdminPathParams.NODE_ID}/settings`, 'settings/nodes/NodeSettingsPage/NodeSettingsPage')
            .add(AdminPages.NodeRolesAndPermissionsPage, `/admin/settings/places/:${AdminPathParams.NODE_ID}/permissions`, 'settings/nodes/NodeRolesAndPermissionsPage/NodeRolesAndPermissionsPage')
            .add(AdminPages.NodePermissionsPage, `/admin/settings/places/:${AdminPathParams.NODE_ID}/permissions/defaults`, 'settings/nodes/NodePermissionsPage/NodePermissionsPage')
            .add(AdminPages.NodeRoleAndPermissionsManagementPage, `/admin/settings/places/:${AdminPathParams.NODE_ID}/permissions/role/:${AdminPathParams.ROLE_NAME}/:${AdminPathParams.FEATURE_ID}`, 'settings/nodes/NodeRoleAndPermissionsManagementPage/NodeRoleAndPermissionsManagementPage')
            .add(AdminPages.FeaturesPage, '/admin/settings/features', 'settings/features/FeaturesPage/FeaturesPage')
            .add(AdminPages.ContentFeaturesPage, '/admin/settings/features/content', 'settings/features/ContentFeaturesPage/ContentFeaturesPage')
            .add(AdminPages.InboxFeaturesPage, '/admin/settings/features/inbox', 'settings/features/InboxFeaturesPage/InboxFeaturesPage')
            .add(AdminPages.UsersPage, '/admin/settings/users', 'settings/users/UsersPage/UsersPage')
            .add(AdminPages.CommunityBadgesPage, '/admin/settings/users/badges', 'settings/community/CommunityBadgesPage/CommunityBadgesPage')
            .add(AdminPages.CommunityPermissionsPage, '/admin/settings/users/permissions/defaults', 'settings/community/CommunityPermissionsPage/CommunityPermissionsPage')
            .add(AdminPages.CommunityRanksPage, '/admin/settings/users/ranks', 'settings/community/CommunityRanksPage/CommunityRanksPage')
            .add(AdminPages.ManageUsersAdminPage, '/admin/settings/users/manage-users', 'settings/users/ManageUsersAdminPage/ManageUsersAdminPage')
            .add(AdminPages.CommunityRolesAndPermissionsPage, '/admin/settings/users/permissions', 'settings/community/CommunityRolesAndPermissionsPage/CommunityRolesAndPermissionsPage')
            .add(AdminPages.CommunityRoleAndPermissionsManagementPage, `/admin/settings/users/permissions/role/:${AdminPathParams.ROLE_NAME}/:${AdminPathParams.FEATURE_ID}`, 'settings/community/CommunityRoleAndPermissionsManagementPage/CommunityRoleAndPermissionsManagementPage')
            .add(AdminPages.CommunityContentFilterDetailPage, `/admin/settings/features/moderation/filter/:${AdminPathParams.CONTENT_FILTER_NAME}`, 'settings/community/CommunityContentFilterDetailPage/CommunityContentFilterDetailPage')
            .add(AdminPages.SystemPage, '/admin/settings/system', 'settings/system/SystemPage/SystemPage')
            .add(AdminPages.AuditLogPage, '/admin/settings/system/log', 'settings/system/AuditLogPage/AuditLogPage')
            .add(AdminPages.DisplayPage, '/admin/settings/system/display', 'settings/system/DisplayPage/DisplayPage')
            .add(AdminPages.ModerationPage, '/admin/settings/features/moderation', 'settings/features/ModerationFeaturesPage/ModerationFeaturesPage')
            .add(AdminPages.AccountAndPrivacyPage, '/admin/settings/system/account-and-privacy', 'settings/system/AccountAndPrivacyPage/AccountAndPrivacyPage')
            .add(AdminPages.SeoPage, '/admin/settings/system/seo', 'settings/system/SeoPage/SeoPage')
            .add(AdminPages.CommunityUserRolesAndPermissionsManagementPage, `/admin/settings/users/permissions/user/:${AdminPathParams.USER_ID}`, 'settings/community/CommunityUserRolesAndPermissionsManagementPage/CommunityUserRolesAndPermissionsManagementPage')
            .add(AdminPages.NodeUserRolesAndPermissionsManagementPage, `/admin/settings/places/:${AdminPathParams.NODE_ID}/permissions/user/:${AdminPathParams.USER_ID}`, 'settings/nodes/NodeUserRolesAndPermissionsManagementPage/NodeUserRolesAndPermissionsManagementPage')
            .add(AdminPages.OidcProviderEditPage, `/admin/settings/system/account-and-privacy/oauth-oid-provider/:${AdminPathParams.OIDC_PROVIDER_ID}`, 'settings/system/OidcProviderEditPage/OidcProviderEditPage')
            // ANALYTICS pages
            .add(AdminPages.AnalyticsPage, '/admin/analytics', 'analytics/AnalyticsLandingPage/AnalyticsLandingPage')
            .add(AdminPages.DashboardPage, '/admin/analytics/dashboard', 'analytics/DashboardPage/DashboardPage')
            .add(AdminPages.DashboardPresetPage, `/admin/analytics/dashboard/:${AdminPathParams.PRESET_ID}`, 'analytics/DashboardPresetPage/DashboardPresetPage')
            .add(AdminPages.ReportsPage, '/admin/analytics/reports', 'analytics/ReportsPage/ReportsPage')
            .add(AdminPages.ReportsDetailsPage, `/admin/analytics/reports/:${AdminPathParams.REPORT_ID}`, 'analytics/ReportsDetailsPage/ReportsDetailsPage')
            // DEVELOPERS pages
            .add(AdminPages.DevelopersPage, '/admin/dev', 'developers/DevelopersPage/DevelopersPage')
            // DESIGNERS pages
            .add(AdminPages.DesignersPage, '/admin/designer', 'designers/DesignersPage/DesignersPage')
            .add(AdminPages.CommunityTextPage, '/admin/designer/community-text', 'designers/CommunityTextPage/CommunityTextPage')
            .add(AdminPages.SalesforceFeaturesPage, '/admin/settings/features/salesforce', 'settings/features/SalesforceFeaturesPage/SalesforceFeaturesPage')
            .add(AdminPages.CategoryLocaleAssociationPage, '/admin/settings/features/localized-categories', 'settings/features/CategoryLocaleAssociationPage/CategoryLocaleAssociationPage')
            .add(AdminPages.ThirdPartyAnalyticsPage, '/admin/analytics/third-party-analytics', 'analytics/ThirdPartyAnalyticsPage/ThirdPartyAnalyticsPage')
            .add(AdminPages.AutomationRulesPage, '/admin/settings/system/automation-rules', 'settings/system/AutomationRulesPage/AutomationRulesPage')
            .add(AdminPages.AdminHealthCheckPage, '/admin/health', 'healthcheck/HealthCheckPage/HealthCheckPage');
        routesCache.set(key, adminRoutes);
        return adminRoutes;
    }
}
//# sourceMappingURL=adminRoutes.js.map